import React, { useState, useEffect } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Row, Col, Card, CardBody, Form, Spinner } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import {
  putRequestForm,
  postRequest,
  postRequestForm,
} from "../../components/Common/Utils.js";
import Lightbox from "react-image-lightbox";
import FileUpload from "components/Common/FileUpload.js";
import CategoryModal from "components/Modal/CategoryModal.js";
import SubCategoryModal from "components/Modal/SubCategoryModal.js";

export default function ChildCategoryUpdate() {
  const location = useLocation();
  const state = location.state?.row;
  const [SubCategoryData, setSubCategoryData] = useState(null);
  const [previewImage, setPreviewImage] = useState("");
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [model, setModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [startLoader, setStartLoader] = useState(false);
  const [ChildCategoryallData, setChildCategoryallData] = useState({
    Image: "",
    Text: null,
    subCategoryId: "",
    show: false,
  });
  let history = useHistory();

  const { id } = useParams();

  const closeModalCategory = () => {
    setModel(false);
  };

  const selectRow = (item) => {
    console.log({ item });
    setChildCategoryallData({
      Image: item?.image,
      Title: item?.title,
      subCategoryId: item?._id,
      show: true,
    });
    setModel(false);
  };

  const toggleModel = () => {
    setModel(!model);
  };

  useEffect(() => {
    if (!selectedImage) return;
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewImage(reader.result);
    };
    reader.readAsDataURL(selectedImage);
  }, [selectedImage]);

  const showLightBox = (previewImage) => {
    setPreviewImage(previewImage);
    setOpenLightBox(true);
  };

  useEffect(() => {
    if (state) {
      setSubCategoryData(state);
      setPreviewImage(state.image);
      setChildCategoryallData({
        Image: state?.subCategoryId?.image,
        Title: state?.subCategoryId?.title,
        subCategoryId: state?.subCategoryId?._id,
        show: true,
      });
    }
  }, [state]);

  const UpdatedSubCategory = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    const selectedImageForm = new FormData();
    let selectedImageRes = null;
    if (selectedImage) {
      selectedImageForm.append("image", selectedImage);
      setStartLoader(true);
      selectedImageRes = await postRequestForm(
        "image/img/upload",
        selectedImageForm
      );
      setStartLoader(false);
    }
    formData.append("childCategoryId", SubCategoryData._id);
    formData.append("title", SubCategoryData.title);
    formData.append("description", SubCategoryData.description);
    // formData.append("childCategoryId", ChildCategoryallData.subCategoryId);

    if (selectedImageRes?.data?.url) {
      formData.append("image", selectedImageRes.data.url);
    } else {
      console.error("Image URL not found in the response.");
    }

    const response = await postRequestForm(
      "category/update-child-category",
      formData
    );
    setLoading(false);

    if (response.status == 1) {
      toast.success(response.message);
      setTimeout(() => {
        history.goBack();
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const updateValue = (index, value) => {
    const list = { ...SubCategoryData };
    list[index] = value;
    setSubCategoryData(list);
  };

  return (
    <React.Fragment>
      <ToastContainer />

      <div className="row">
        <div className="col-lg-10">
          <div className="page-title-box">
            <h4>Category Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">Category Management</li>:{" "}
              <li className="breadcrumb-item">Update Child Category</li>
            </ol>
          </div>
        </div>
        <div class="col-md-2 text-end">
          <button type="button"  onClick={()=>history.goBack()}className="btn btn-primary btn-lg">
            <i class="fas fa-chevron-left"></i> Back
          </button>
        </div>
      </div>
      <Row>
        <Col lg={12}>
          <Card>
            {loading ? (
              <CardBody style={{ height: "100px" }}>
                <Spinner
                  color="info"
                  style={{
                    height: "4rem",
                    width: "4rem",
                    position: "absolute",
                    left: "50%",
                  }}
                >
                  Loading...
                </Spinner>
              </CardBody>
            ) : (
              <CardBody>
                <h4 className="card-title"> Update Child Category</h4>
                <Form onSubmit={UpdatedSubCategory}>
                  <Row>
                    <Col lg={12} className="ms-lg-auto">
                      <div className="mt-5 mt-lg-4">
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">
                            Title
                          </label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={(e) =>
                                updateValue("title", e.target.value)
                              }
                              value={SubCategoryData?.title}
                              // defaultValue={SubCategoryData?.SubsubCategoryId}
                              name="title"
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">
                            Description
                          </label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={(e) =>
                                updateValue("description", e.target.value)
                              }
                              value={SubCategoryData?.description}
                              name="tags"
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">
                            Sub Category
                          </label>

                          <div
                            className="col-sm-6"
                            
                            // onClick={() => {
                            //   toggleModel();
                            // }}
                          >
                            {ChildCategoryallData.show ? (
                              <div class="input-group">
                                <button
                                  class="btn"
                                  style={{
                                    border: "1px solid #ced4da",
                                    background: "#f08d63",
                                    color: "#ffff",
                                  }}
                                  type="button"
                                  id="chooseCategoryBtn"
                                //   onclick={() => toggleModel()}
                                >
                                  (can't change)
                                </button>
                                <div
                                  style={{
                                    border: "1px solid #ced4da",
                                    width: "16px",
                                  }}
                                ></div>
                                <img
                                  src={ChildCategoryallData?.Image}
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    border: "1px solid #ced4da",
                                    borderRight: "none",
                                    borderLeft: "none",
                                  }}
                                ></img>
                                <input
                                  type="text"
                                  style={{ borderLeft: "none" }}
                                  class="form-control"
                                  readonly
                                  value={ChildCategoryallData?.Title}
                                  id="selectedCategory"
                                  placeholder="No Sub Category chosen"
                                />
                              </div>
                            ) : (
                              <div class="input-group">
                                <button
                                  class="btn"
                                  style={{
                                    border: "1px solid #ced4da",
                                    background: "#f08d63",
                                    color: "#ffff",
                                  }}
                                  type="button"
                                  id="chooseCategoryBtn"
                                //   onclick={() => toggleModel()}
                                >
                                  Choose Category
                                </button>
                                <input
                                  type="text"
                                  class="form-control"
                                  readonly
                                  id="selectedCategory"
                                  placeholder="No  Sub Category chosen"
                                />
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="row mb-4">
                          <label
                            htmlFor="horizontal-password-input"
                            className="col-sm-3 col-form-label"
                          >
                            File
                          </label>
                          <div className="col-sm-6">
                            <input
                              type="file"
                              onChange={(e) =>
                                setSelectedImage(e.target.files[0])
                              }
                              name="mediaUrl"
                              className="form-control"
                              id="horizontal-password-input"
                            />
                            <br />
                            {previewImage && (
                              <img
                                src={previewImage}
                                onClick={() => showLightBox(previewImage)}
                                style={{ width: "100px", height: "100px" }}
                              />
                            )}
                          </div>
                        </div>

                        <div className="mt-5 mt-lg-4">
                          <div className="row justify-content-end">
                            <div className="col-sm-9">
                              <div>
                                <button
                                  type="submit"
                                  className="btn btn-primary w-md"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            )}
          </Card>
        </Col>
      </Row>
      {openLightbox && (
        <Lightbox
          mainSrc={previewImage}
          onCloseRequest={() => setOpenLightBox(false)}
        />
      )}

      <SubCategoryModal
        show={model}
        closeModal={closeModalCategory}
        selectRow={selectRow}
      />

      <FileUpload message="File Uploading" status={startLoader} />
    </React.Fragment>
  );
}
